/**
 * URL search-param keys used across multiple views/files.
 * Keep these centralised so renames stay consistent everywhere
 * a key is read or written.
 */
export const SEARCH_PARAM = {
  /** Legacy public-search type discriminator kept in query strings. */
  SEARCH_TYPE: 'searchType',
  /** Sale catalogue identifier used when linking to sale detail views. */
  SALE_ID: 'saleId',
  /** Lot number filter / catalogue context on sale listing and animal detail. */
  LOT_NO: 'lotNo',
  /** Active tab on entity profile / config pages. */
  TAB: 'tab',
  /** Form mode toggle (e.g. "edit"). */
  MODE: 'mode',
  /** Work-order ID for the orders flow. */
  WORK_ORDER_ID: 'woid',
  /** Force a file download instead of inline render. */
  DOWNLOAD: 'download',
  /** Suggested filename for downloads. */
  FILENAME: 'filename',
  /** Account linking success query marker. */
  LINKED: 'linked',
  /** Account linking/auth callback error marker. */
  ERROR: 'error',
} as const;

export const SEARCH_PARAM_VALUE = {
  TRUE: '1',
} as const;
